{
  "generic": "Ett fel uppstod",
  "networkError": "Nätverksfel - kontrollera din anslutning",
  "unauthorized": "Du har inte behörighet att utföra denna åtgärd",
  "notFound": "Den begärda resursen hittades inte",
  "serverError": "Serverfel - försök igen senare",
  "validationError": "Kontrollera din inmatning",
  "uploadFailed": "Uppladdning misslyckades",
  "uploadSuccess_one": "{{count}} fil uppladdad",
  "uploadSuccess_other": "{{count}} filer uppladdade",
  "invalidFileType": "Ogiltig filtyp",
  "fileTooLarge": "Filen är för stor",
  "sessionExpired": "Din session har gått ut. Logga in igen.",
  "loadAgentsFailed": "Kunde inte ladda agenter",
  "loadProfileFailed": "Kunde inte ladda användarprofil",
  "stream": {
    "hitl_question_undelivered": "Vi kunde inte leverera assistentens fråga. Uppdraget kan fortfarande pågå.",
    "subscription_forbidden": "Du har inte åtkomst till den här körningen.",
    "subscription_unavailable": "Liveuppdateringar för den här körningen är inte tillgängliga just nu. Försök igen.",
    "control_forbidden": "Du kan inte styra den här körningen.",
    "control_unavailable": "Den här körningen kan inte stoppas, pausas eller återupptas just nu. Försök igen om en stund.",
    "conversation_not_viewable": "Den här konversationen tillhör en annan person. Bara den personen kan läsa den här."
  }
}
